export const trimWhitespaceAtStart = (value = '') =>
  /^\s/.test(`${value}`) ? `${value}`.trim() : value;
